import React from 'react'

export type Location = {
    reload: () => void
    href: string
}

export default React.createContext<Location>(location)
